<template>
  <pt-export-history-table class="pt-export-history-table__withData" :tableLabels="tableLabels" @getTableData="getTableData" ref="table"
                           :total-number="totalNumber" :page-size="pageSize" :tableData="tableData">
    <slot />
  </pt-export-history-table>
</template>

<script>
import PtExportHistoryTable from './index'
export default {
  name: 'pt-export-history-table__withData',
  props: {
    tableLabels: {
      type: Array,
      default: function () {
        return []
      }
    },
    pageSize: {
      type: Number,
      default: 10
    },
    queryName: {
      type: String,
      default: ''
    },
    routerName: {
      type: String,
      default: ''
    }
  },
  computed: {
    page () {
      return this.$refs.table.page
    }
  },
  data () {
    return {
      totalNumber: 0,
      loading: false,
      tableData: []
    }
  },
  watch: {
    queryName: {
      handler (val) {
        this.getTableData(0)
      },
      deep: true
    }
  },
  components: {
    'pt-export-history-table': PtExportHistoryTable
  },
  methods: {
    // 获取导出的数据类型
    // getExportType () {
    //   switch (this.queryName) {
    //     case 'order':this.resourceConfig = 'mall_order_export'
    //       break
    //     default :this.resourceConfig = null
    //       break
    //   }
    // },
    getTableData (page, next) {
      //   this.getExportType()
      let data = {
        example: {
          resourceConfig: this.queryName
        },
        pageable: {
          page: this.page,
          size: this.pageSize,
          sort: 'createdDate,desc'
        }
      }
      if (!next) {
        this.loading = true
      }
      let apiUrl
      switch (this.routerName) {
        case 'counselor-qr-code':
        case 'doctor-qr-code-history':
          apiUrl = 'exportHistoryOfCustomer'
          break
        default:
          switch (this.queryName) {
            case 'adultlab_export':
              apiUrl = 'AdultlabExportHistoryList'
              break
            case 'mall_user_export':
              apiUrl = 'exportHistoryOfCustomer'
              break
            case 'points_order_export':
              apiUrl = 'exportHistoryOfIntegral'
              break
            case 'points_details_export':
              apiUrl = 'exportHistoryOfMembers'
              break
            case 'pay_order_export':
              apiUrl = 'exportHistoryListPay'
              break
            case 'insure_material_export':
            case 'object_log_export':
              apiUrl = 'exportHistoryListFormerop'
              break
            case 'lab_export':
              apiUrl = 'labExportHistoryList'
              break
            default:
              apiUrl = 'exportHistoryList'
              break
          }
          break
      }
      this.$store.dispatch(apiUrl, data).then(res => {
        this.totalNumber = res.totalNumber
        this.tableData = res.data
        this.loading = false
        if (next) {
          next(res.data)
        }
      }).catch(err => {
        this.loading = false
        this.$message(err || '获取导出历史失败')
      })
    }
  },
  created () {
  }
}
</script>
